<script>
  export let styles = {};

  $: style = Object.entries(styles).reduce((acc, [k, v]) => {
    return acc + `--${k}: ${v};`;
  }, '');
</script>

<div class="title-outline" {style}>
  <slot />
</div>

<style>
  .title-outline {
    --stroke: var(--color-accent);
    --fill: transparent;
  }

  .title-outline > :global(*) {
    color: var(--stroke, #460918);
    -webkit-text-fill-color: var(--fill, #fff); /* Will override color (regardless of order) */
    -webkit-text-stroke-width: 1.6px;
    -webkit-text-stroke-color: var(--stroke, #460918);
    font-size: 30px;
    font-weight: 700;
    letter-spacing: 0.11em;
    text-align: center;
    text-transform: uppercase;
  }

  @media screen and (min-width: 768px) {
    .title-outline > :global(*) {
      font-size: 40px;
    }
  }
</style>
